export default "__VITE_ASSET__By0gFo3b__"